<template>
    <div class="py-2">
      
      <label for="{{forLabel}}" class="block text-sm font-medium text-gray-700"><span v-if="required" class="text-rose-600">*</span> {{label}}</label>
      <div class="mt-1">
        <div class="flex flex-col w-full" >

          <div v-for="(cordinate,index) in listCoordinates.coordinates" :key="index" class="flex items-center gap-2 pb-2 pl-2">
            
            <div>
                <div class="text-xs">
                    {{ label_x }} :
                </div>
                <div>
                    <input type="text" :name="'x_' + index" v-model="cordinate.x" class="defaultInput" :class="name ? fieldsError[field_id] ? 'bg-rose-50' : '': ''">
                </div>
            </div>
            <div>
                <div class="text-xs">
                    {{ label_y }} :
                </div>
                <div>
                <input type="text" :name="'y_' + index" v-model="cordinate.y" class="defaultInput" :class="name ? fieldsError[field_id] ? 'bg-rose-50' : '': ''">
                </div>            
            </div>

            <div v-if="index != 0">
              <XMarkIcon @click="removeCoordinate(index)" class="cursor-pointer h-6 w-6 rounded-full bg-gray-100 p-1 hover:bg-rose-600 hover:text-white" />
            </div>
          </div>
          <div @click="addCoordinate" class="flex justify-center items-center rounded-md w-[140px] bg-gray-100 hover:bg-gray-200 text-xs p-1 cursor-pointer">+ Adicionar</div>
        </div>
      
      </div>
    </div>
    
  </template>
  
  <script>

import { XMarkIcon } from '@heroicons/vue/24/solid';

  
  export default {
      name: 'Coordinates',
      props: {
        value: {
          type: Object,
          required: false,
        },
        name: {
            type: String,
            required: false,
        },
        field_id: {
            type: [String, Number],
            required: false,
        },
        label: {
          type: String,
          required: false,
        },       

        label_x: {
          type: String,
          required: false,
        },

        label_y: {
          type: String,
          required: false,
        },


        required: {
          type: Boolean,
          required: false,
          default: false,
        }, 
        
        fieldsError: {
          type: Object,
          required: false,
        },            

      },
  
      data() {
          return {
            errorClass: '',
            listCoordinates: {
              id: this.field_id,
              label: this.label,
              name: this.name,
              coordinates: [
                {
                  x: '0',
                  y: '0',
                },
              ],
            }
          }
      },
  
      methods: {

        addCoordinate() {
          this.listCoordinates.coordinates.push({
            x: '',
            y: '',
          });
        },

        removeCoordinate(index) {
          this.listCoordinates.coordinates.splice(index, 1);
        },
        
 
      },
      
      watch: {
        listCoordinates: {
          handler: function (val, oldVal) {
            this.$emit('update:modelValue', this.listCoordinates);
          },
          deep: true,
        },
               
      },
     
      created() {
        if (this.value) {
          this.listCoordinates.coordinates = this.value;
        }
        
      },

        components: {
          XMarkIcon,
        },

  }
  </script>